export enum ECacheKey {
  loader = 'loader',
}
